export { default as NoticiasCampañasList } from './Listar';
export { default as NoticiasCampañasCrear } from './Crear'
